import Projects from './Projects'
import Show from './Show'
import Details from './project/Details'
import Stage1 from './Stage1'
import Stage2 from './Stage2'
import Stage3 from './Stage3'

import Requirements from './project/requirements'
import Userstories from './project/Userstories'
import ActivityLogList from './project/ActivityLogList'
import ActivityLogDrawer from './project/ActivityLogDrawer'
import ActivityLogListItem from './project/ActivityLogListItem'
import Costing from './project/stage2/Costing'

import ScrumBoard from './project/scrumboard/ScrumBoard'
import StoryDetail from './project/scrumboard/StoryDetail'
import StoryPreview from './project/scrumboard/Preview'

import SprintPlanner from './project/sprintplanner/SprintPlanner'
import IssueBoard from './project/issueboard/IssueBoard'

import Overview from './project/Overview'
import Deliverables from './project/Deliverables'

export default {
    Projects,
    Show,
    Details,
    Stage1,
    Stage2,
    Stage3,
    Requirements,
    Userstories,
    ActivityLogList,
    ActivityLogDrawer,
    ActivityLogListItem,
    Costing,
    ScrumBoard,
    StoryDetail,
    StoryPreview,
    Overview,
    Deliverables,
    SprintPlanner,
    IssueBoard
}
